<div class="live-indicator">
  <span class="live-indicator__dot {{ liveModeClass }}"></span>
  <span class="live-indicator__text">{{ text }}</span>
</div>
